module.exports = __webpack_public_path__ + "img/motorcycle.b64f8fd4.jpg";